import React from "react";
import { StyleSheet, View } from "react-native";
import { Button as _Button } from "src/common/assets/mixins";
import { StoresType } from "src/common/types/response/stores";
import StoreItem from "./StoreItem";
import { useNavigation } from "@react-navigation/native";
import CustomFlatList from "./flatlist";
import { TABLET_PC } from "../libs/utils/constants";
import { ScrollHandlerProcessed } from "react-native-reanimated";

const Stores = ({
  data,
  style,
  itemStyle,
  lastItemStyle,
  showsVerticalScrollIndicator,
  numColumns,
  oddItemStyle,
  evenItemStyle,
  headerComponent,
  onEndReachedThreshold,
  reAnimated,
  onScroll,
  onEndReached,
  ...props
}: {
  data: StoresType;
  horizontal?: boolean;
  itemStyle?: object;
  lastItemStyle?: object;
  oddItemStyle?: object;
  evenItemStyle?: object;
  style?: object;
  showsVerticalScrollIndicator?: boolean;
  numColumns?: number;
  onEndReachedThreshold?: number;
  headerComponent?;
  reAnimated?: boolean;
  onScroll?: ScrollHandlerProcessed<Record<string, unknown>>
  onEndReached?: () => void;
}) => {
  const length = data?.length;
  const navigation = useNavigation<any>();

  const dataToRender = [...data];
  const numRows = Math.ceil(length / numColumns);
  for (let i = 0; i < numRows * numColumns - length; i++) {
    dataToRender.push({ meta: true, _id: `06${i}` });
  }

  const onStorePress = (id) => {
    navigation.navigate(
      "StoreDetail" as never,
      {
        id,
      } as never
    );
  };

  const renderItem = ({ item, index }) => {
    return (
      <StoreItem
        data={item}
        onPress={onStorePress}
        style={itemStyle}
        oddItemStyle={index % numColumns != 0 ? { ...oddItemStyle } : {}}
        evenItemStyle={index % numColumns == 0 ? { ...evenItemStyle } : {}}
        lastItemStyle={index < length - 1 ? {} : lastItemStyle}
      />
    );
  };

  return (
    <CustomFlatList
      data={dataToRender}
      renderItem={renderItem}
      style={style}
      showsVerticalScrollIndicator={false}
      numColumns={numColumns}
      onEndReached={onEndReached}
      onEndReachedThreshold={onEndReachedThreshold}
      keyboardShouldPersistTaps="always"
      ListHeaderComponent={headerComponent}
      {...props}
    ></CustomFlatList>
  );
};

const styles = StyleSheet.create({
  metaView: {
    flex: 1,
  },
});

export default Stores;
